export default "__VITE_ASSET__5w3eY0Au__"